import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { TabsLayout } from '@/layouts/TabsLayout'
import type { TabNavigationItem } from '@/components/Tabs/TabsNavigation'

const TAB_VISAO_GERAL: TabNavigationItem = {
  value: 'visao-geral',
  label: 'Visão Geral',
  icon: 'mdi:view-dashboard-outline',
  to: '/meus-distribuidores',
}

const TAB_LISTA: TabNavigationItem = {
  value: 'lista',
  label: 'Lista',
  icon: 'mdi:account-group-outline',
  to: '/meus-distribuidores/lista',
}

const TAB_SALDO: TabNavigationItem = {
  value: 'saldo',
  label: 'Saldo manual',
  icon: 'mdi:wallet-outline',
  to: '/meus-distribuidores/saldo',
}

const TAB_RELATORIO: TabNavigationItem = {
  value: 'relatorio',
  label: 'Relatório',
  icon: 'mdi:file-chart-outline',
  to: '/meus-distribuidores/relatorio',
}

function isDistribuidoresSaldoPath(pathname: string): boolean {
  return (
    pathname === '/meus-distribuidores/saldo' ||
    pathname.startsWith('/meus-distribuidores/saldo/')
  )
}

export function DistribuidoresTabsLayout() {
  const { pathname } = useLocation()

  const tabs = useMemo(() => {
    const showSaldoTab = isDistribuidoresSaldoPath(pathname)
    if (showSaldoTab) {
      return [TAB_VISAO_GERAL, TAB_LISTA, TAB_SALDO, TAB_RELATORIO]
    }
    return [TAB_VISAO_GERAL, TAB_LISTA, TAB_RELATORIO]
  }, [pathname])

  return (
    <TabsLayout
      title="Distribuidores"
      subtitle="Gerencie distribuidores, comissões e afiliados vinculados"
      tabs={tabs}
    />
  )
}
